// src/app/ui/top-progress-bar.component.ts
import { Component } from "@angular/core";
import { NgIf } from "@angular/common";
import { LoadingService } from "./service/loading.service";

@Component({
  selector: "app-top-progress-bar",
  standalone: true,
  imports: [NgIf],
  template: `
    <div class="topbar" *ngIf="loading.isVisible()">
      <div class="bar"></div>
    </div>
  `,
  styleUrls: ["./top-progressbar.component.scss"],
})
export class TopProgressBarComponent {
  constructor(public loading: LoadingService) {}
}
